import * as React from 'react';
import { ArticleParagraph3, useDeviceType } from '@cian/ui-kit';

import { InlineLink } from '../../InlineLink';

interface IPersonalAgreementProps {
  policyUrl: string;
  personalDataAgreement: string;
}

export const PersonalAgreement: React.FC<IPersonalAgreementProps> = ({ policyUrl, personalDataAgreement }) => {
  const deviceType = useDeviceType();

  const textAlign = deviceType === 'phone' ? 'center' : 'left';

  return (
    <ArticleParagraph3 color="gray60_100" textAlign={textAlign}>
      Нажимая кнопку, я соглашаюсь на{' '}
      <InlineLink href={personalDataAgreement} target="_blank" rel="noopener noreferrer">
        обработку персональных данных
      </InlineLink>
      <br /> в соответствии с{' '}
      <InlineLink href={policyUrl} target="_blank" rel="noopener noreferrer">
        политикой конфиденциальности
      </InlineLink>
    </ArticleParagraph3>
  );
};
